(function () {
  'use strict';
  angular.module('claims')
    .component('claimLines', {
        bindings: {
          promise: '<'
        },
        controller: [ '$state', '$rootScope', function claimLinesComponent($state, $rootScope) {
          var ctrl = this;
          $rootScope.rootFlag = true;
          this.$onInit = function () {
            getClaimLines();
          };

          function getClaimLines() {
        	ctrl.running = true;
            if (ctrl.promise) {
              ctrl.promise.then(function(response) {
              ctrl.serviceUnavailable = response.serviceUnavailable;
              if(response.data){
            	
            	ctrl.totBilledAmt     = 0;
                ctrl.totAllowedAmt    = 0;
                ctrl.totNotCoveredAmt = 0;
                ctrl.totDeductible    = 0;
                ctrl.totPaidAmt       = 0;
                ctrl.totMemberResponsibility = 0;  
            	
            	_.each(response.data.lineDetail, (row) => {
                var rson = "";
                _.each(row.reasonCodes, (rc) => {
                  rson = rson+rc+"\n";  
                });
                row.reasonCode = rson;
                
                ctrl.totBilledAmt     = (row.billedAmount && !isNaN(row.billedAmount)) ? (ctrl.totBilledAmt + Number(row.billedAmount)) : ctrl.totBilledAmt;
                ctrl.totAllowedAmt    = (row.allowedAmount && !isNaN(row.allowedAmount)) ? (ctrl.totAllowedAmt + Number(row.allowedAmount)) : ctrl.totAllowedAmt;
                ctrl.totNotCoveredAmt = (row.notCoveredAmount && !isNaN(row.notCoveredAmount)) ? (ctrl.totNotCoveredAmt + Number(row.notCoveredAmount)) : ctrl.totNotCoveredAmt;
                ctrl.totDeductible    = (row.deductible && !isNaN(row.deductible)) ? (ctrl.totDeductible + Number(row.deductible)) : ctrl.totDeductible;
                ctrl.totPaidAmt       = (row.paidAmount && !isNaN(row.paidAmount)) ? (ctrl.totPaidAmt + Number(row.paidAmount)) : ctrl.totPaidAmt;
                ctrl.totMemberResponsibility = (row.memberResponsibility && !isNaN(row.memberResponsibility)) ? ctrl.totMemberResponsibility + Number(row.memberResponsibility) : ctrl.totMemberResponsibility;
               
              }); 
                ctrl.claimLinesSearchResults = response.data.lineDetail ;
              }
              else {
                ctrl.claimLinesSearchResults = [];
              }
              ctrl.running = false;
              }, function(rejection) {
                ctrl.running = false;
              });
            }
          }
       }],
       templateUrl: 'js/claims/claimLines.html' + appVersion
      }
    );
})();


